<template>
  <el-col :span="23">
    <el-form ref="form" :model="form" label-width="140px" class="form">
      <create5
        ref="create"
        :projectArr="projectArr"
        :teamArr="teamArr"
        :userData="userData"
        :formByFather="form"
      ></create5>

      <div class="tip" style="margin: 20px 0 0 40px">* 相关附件</div>
      <div class="clear">
        <el-form-item label="上传附件">
          <attachments
            :projectId="form.projectId"
            :contractId="form.contractId"
            ref="attachments"
            :arr="attachmentArr"
            :type="2"
          ></attachments>
        </el-form-item>
      </div>

      <div class="tip" style="margin: 20px 0 0 40px">* 意见与审批</div>
      <div class="clear label-mx">
        <el-form-item label="审批方式">
          <div class="approve">
            <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
            <el-radio v-model="approvalType" label="1">平行审批</el-radio>
          </div>
        </el-form-item>

        <!-- 审批 -->
        <approval-item
          ref="approval"
          :approvalUsers="approvalUsers.c2_4"
          :selectArr="selectArr"
          :approvalSetDep="approvalSetDep"
        ></approval-item>
      </div>

      <el-form-item label="">
        <div class="form-btn-room">
          <el-button
            :loading="formLoading"
            @click="createProject()"
            class="form-btn"
            type="success"
            >{{ formBtnText }}</el-button
          >
          <el-button
            @click="$router.back()"
            v-if="form.applyId"
            type="info"
            plain
            >取消修改</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </el-col>
</template>


<script>
import { mapState } from "vuex";
import Attachments from "@/components/Attachments";
import approvalUsers from "@/Mixins/approvalUsers";

import ApprovalItem from "@/components/ApprovalItem";
import Create5 from "@/page/form/create5";
export default {
  components: {
    ApprovalItem,
    Create5,
    Attachments,
  },
  props: ["teamArr", "projectArr", "objectType"],
  mixins: [approvalUsers],
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      formDefault: {},
      form: {
        number: "",
        depId: "",
        leaderId: "",
        teamId: "",
        level: 0,
        parentProjectId: "",
        // 子项目类型
        ctype: "",

        name: "",
        iszb: "1",
        intro: "",

        underLine: "",

        // 实施类别
        sslb: "",
        // 微型项目类别 A
        wxType: "",
      },

      // 附件
      attachmentArr: [],
      // 审批
      approvalType: "0",
      formLoading: false,

      applyInfo: "",
      formBtnText: "确认提交项目申请",
    };
  },
  created() {
    this.form.wxType = this.objectType;
    this.formDefault = JSON.parse(JSON.stringify(this.form));
    this.getApplyData();
  },
  mounted() {
    this.form.depId = this.userData.secDepIds.split(",")[0];
    this.form.leaderId = this.userData.id;
  },
  methods: {
    getApplyData() {
      this.form.applyId = this.$route.params.applyId;
      if (this.form.applyId) {
        this.formLoading = true;
        this.getProjectApplyInfo();
        this.formBtnText = "确认修改项目申请表";
      } else {
        this.form = JSON.parse(JSON.stringify(this.formDefault));
        this.attachmentArr = [];
        this.applyInfo = "";
        this.setSelectArr(this.applyInfo, 2, 4);
        this.formLoading = false;
        this.formBtnText = "确认提交项目申请";
      }
    },
    getProjectApplyInfo() {
      ajax.get("/gc/project/apply/info/" + this.form.applyId, "", (res) => {
        this.applyInfo = res.vo;

        this.form.depId = this.applyInfo.project.depId;
        this.form.leaderId = this.applyInfo.project.leader.id;
        this.form.teamId = this.applyInfo.project.team
          ? this.applyInfo.project.team.id
          : "";
        this.form.level = this.applyInfo.project.level;
        if (this.applyInfo.project.father) {
          this.form.parentProjectId = this.applyInfo.project.father.id;
        }

        this.form.name = this.applyInfo.project.name;
        this.form.iszb = this.applyInfo.iszb.toString();
        this.form.intro = this.applyInfo.intro;

        this.form.xmgs = this.applyInfo.xmgs / 1;
        this.form.xmgq = this.applyInfo.xmgq / 1;

        this.form.underLine = this.applyInfo.underLine.toString();

        this.attachmentArr = this.applyInfo.attachments
          ? this.applyInfo.attachments
          : [];

        this.setSelectArr(this.applyInfo, 2, 4);
        this.formLoading = false;
      });
    },
    // 提交项目申请
    createProject() {
      this.form = this.$refs.create.getFromData();
      if (this.form.underLine == "") {
        this.$message.error("请标注本次审批是否已线下通过");
        return;
      }

      if (!this.form.name || !this.form.intro) {
        this.$message.error("项目名称与项目介绍不能为空");
        return;
      }

      // 判断选择了子项目，但父项目未选的情况下，提示
      if (this.form.level == 1 && !this.form.parentProjectId) {
        this.$message.error("该项目你选择了子项目类型，请选择对应的父项目");
        return;
      }

      // 组装审批人
      this.form.type = 4;
      this.form.approvalType = this.approvalType;
      this.form.approvalUserIds = this.$refs.approval.getUserIds();
      if (!this.form.approvalUserIds) {
        this.$message.error("审批人员不能一个都不选择");
        return;
      }

      this.form.attachments = this.$refs.attachments.getAttachments();

      this.formLoading = true;

      let _url = !this.form.applyId
        ? "/gc/project/apply"
        : "/gc/project/apply/edit";

      ajax.post(
        _url,
        this.form,
        (res) => {
          this.formLoading = false;
          if (!this.form.applyId) {
            this.$message.success("提交项目申请成功，请耐心等待领导审批");
          } else {
            this.$message.success("修改项目成功，请耐心等待领导审批");
          }
          this.$router.push("/Project/Detail/" + res.vo.project.id);
        },
        (res) => {
          this.formLoading = false;
        }
      );
    },
  },
  watch: {
    objectType() {
      this.form.wxType = this.objectType;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/project/formLayout/create_5.vue